import React from "react";
import styles from "./style.module.scss";

const BADGE_TEXT_MAP = {
  recommended: "RECOMMENDED",
  brokerInsight: "BROKER INSIGHT",
  sfRecommended: "SQUAREFOOT RECOMMENDED",
  virtualTour: "VIRTUAL TOUR",
};

interface IProps {
  type: "recommended" | "brokerInsight" | "sfRecommended" | "virtualTour";
  className?: string;
  badgeText?: string | null;
}

const ListingBadge = ({
  type,
  className = "",
  badgeText = null,
  ...props
}: IProps) => (
  <span
    className={`${className} ${styles.listingBadge} ${styles[type]}`}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {badgeText || BADGE_TEXT_MAP[type]}
  </span>
);

export default ListingBadge;
